(function () {
  'use strict';

  var enhancementQueued = false;

  function enhanceReviewWidgets() {
    enhancementQueued = false;

    document.querySelectorAll('.yotpo-reviews-main-widget').forEach(function (widget) {
      widget.querySelectorAll('.yotpo-thumbnail[alt]').forEach(function (thumbnail) {
        var control = thumbnail.parentElement;
        var label = thumbnail.getAttribute('alt');

        if (!control || control.tabIndex < 0 || !label) return;
        control.setAttribute('role', 'button');
        control.setAttribute('aria-label', label);
      });

      widget.querySelectorAll('.yotpo-media-filter[tabindex]').forEach(function (control) {
        var input = control.querySelector('input[type="checkbox"], input[role="checkbox"]');

        function syncCheckedState() {
          var isChecked = input && input.type === 'checkbox'
            ? input.checked
            : control.getAttribute('aria-checked') === 'true';

          control.setAttribute('role', 'checkbox');
          control.setAttribute('aria-label', 'Show reviews with media');
          control.setAttribute('aria-checked', isChecked ? 'true' : 'false');
        }

        syncCheckedState();

        if (control.dataset.mosieYotpoStateSync) return;

        control.dataset.mosieYotpoStateSync = 'true';
        if (input && input.type === 'checkbox') {
          input.addEventListener('change', syncCheckedState);
        }
        control.addEventListener('click', function () {
          window.setTimeout(syncCheckedState, 0);
        });
        control.addEventListener('keyup', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            window.setTimeout(syncCheckedState, 0);
          }
        });
      });
    });
  }

  function queueEnhancement() {
    if (enhancementQueued) return;
    enhancementQueued = true;
    window.requestAnimationFrame(enhanceReviewWidgets);
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceReviewWidgets();
    new MutationObserver(queueEnhancement).observe(document.body, { childList: true, subtree: true });
  });
})();
